import { mapRImage } from '../../../api/helpers';
import { removeEmptyValues } from '../../../utils';
import { Testimonial } from '../domain/testimonial';
import { RTestimonial } from '../remote/testimonial';

export const mapTestimonial = (rTestimonial: RTestimonial): Testimonial => {
    return {
        id: rTestimonial.documentId,
        firstname: rTestimonial.firstname,
        lastname: rTestimonial.lastname,
        position: rTestimonial.jobTitle ?? undefined,
        picture: mapRImage(rTestimonial.picture),
        quote: rTestimonial.quote
    };
};

export const mapTestimonials = (rTestimonials?: RTestimonial[] | null): Testimonial[] =>
    rTestimonials ? removeEmptyValues(rTestimonials.map(mapTestimonial)) : [];
